<template>
	<div class="app-container holdTab">
		<!-- 数据列表 -->
		<el-table v-loading="loading" element-loading-text="加载中" :data="list">
			<el-table-column label="序号" align="center" type="index" width="50" />
			<el-table-column label="赛事名称" align="center" prop="gameName" />
			<el-table-column label="赛事类型" align="center" prop="typeName" />
			<el-table-column label="赛事项目" align="center" prop="itemName" />
			<el-table-column label="举办地点" align="center" prop="provinceName"></el-table-column>
			<el-table-column label="审核状态" align="center" prop="isCheck">
				<template slot-scope="scope">
					<span class="statusTag warn" v-if="scope.row.isCheck == '1'"> 待审核 </span>
					<span class="statusTag danger" v-if="scope.row.isCheck == '2'"> 审核拒绝 </span>
					<span class="statusTag success" v-if="scope.row.isCheck == '3'"> 审核通过 </span>
				</template>
			</el-table-column>
			<el-table-column label="赛事进度" align="center" prop="state">
				<template slot-scope="scope">
					<span class="statusTag gray" v-if="scope.row.state == '1'"> 已结束 </span>
					<span class="statusTag success" v-if="scope.row.state == '2'"> 进行中 </span>
					<span class="statusTag primary" v-if="scope.row.state == '3'"> 报名中 </span>
					<span v-if="scope.row.isCheck == '2'"> - </span>
				</template>
			</el-table-column>
			<el-table-column label="赛事人数" align="center" prop="isLimit">
			</el-table-column>
			<el-table-column label="报名时间" align="center" prop="applyStartTime">
				<template slot-scope="scope">
					<div>{{ parseTime(scope.row.applyStartTime, '{y}-{m}-{d} {h}:{i}') }}</div>
					<div>——</div>
					<div>{{ parseTime(scope.row.applyEndTime, '{y}-{m}-{d} {h}:{i}') }}</div>
				</template>
			</el-table-column>
			<el-table-column label="活动时间" align="center" prop="gameStartTime">
				<template slot-scope="scope">
					<div>{{ parseTime(scope.row.gameStartTime, '{y}-{m}-{d} {h}:{i}') }}</div>
					<div>——</div>
					<div>{{ parseTime(scope.row.gameEndTime, '{y}-{m}-{d} {h}:{i}') }}</div>
				</template>
			</el-table-column>
			<el-table-column label="提交时间" align="center" prop="createTime">
			</el-table-column>
			<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
				<template slot-scope="scope">
					<el-button size="small" plain type="primary" @click="handleDtl(scope.row)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
			:limit.sync="queryParams.pageSize" @pagination="_getList" />
	</div>
</template>

<script>
	import * as API_User from "@/api/sportManage/user";

	export default {
		name: "public",
		props: ["id","name"],
		data() {
			return {
				pageName: '举办赛事',
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				list: [],
				total: 0,
				loading: false,
			};
		},
		watch: {
			name: {
			handler(newVal, oldVal) {
				if(newVal == 'hold') this._getList()
			},
			}
		},
		created() {},
		methods: {
			// 接口-用户列表
			_getList() {
				API_User.matchList({
					memberId: this.id
				}).then((res) => {
					console.log(res.data.list)
					this.total = res.data.total;
					this.list = res.data.list;
					// for(let i = 0;i<this.list.length;i++){
					// 	let list = []
					// 	list = this.list[i].itemName.split(',')
					// 	let itemName = []
					// 	for (let j = 0; j < list.length; j++) {
					// 		itemName.push(list[j].split('-')[1])
					// 	}
					// 	let name = ''
					// 	for (var k = 0; k < itemName.length; k++) {
					// 		name += itemName[k] + ",";
					// 	}
					// 	if (name.length > 0) {
					// 		name = name.substr(0, name.length - 1);
					// 	}
					// 	this.list[i].itemName = name
					// }
				}).catch((err) => {

				});
			},
			//跳转-用户详情
			handleDtl(row) {
				console.log(row);
				this.$router.push({
					path: '/games/detail',
					query: {
						id: row.id,
					},
				})
			},
		},
	};
</script>

<style scoped lang="scss">
.holdTab {
	padding: 20px 0;
}
</style>